import React from "react";
import "assets/css/main.scss";
import ContractFormClientiCasnici from "pages/ContractFormClientiCasnici";
 console.log(process.env.REACT_APP_ENV);

window.dataLayer = window.dataLayer || [];

function App() {
   return <ContractFormClientiCasnici />;
}

export default App;
